import React, { useCallback } from "react"
import * as AppConstants from "@/utility/AppConstants"
import "Css/table.css"
import { TableFieldsMultiAnno } from "@/utility/model"

function TabIndicatoriSpecifici(props: TableFieldsMultiAnno) {
    let elemNonDisponibile = AppConstants.ELEMENTO_NON_DISPONIBILE

    return (
        <React.Fragment>
            {/*    
                <tr>
                    <th className="th_punteggio_isa"> {AppConstants.TITLE_FREQUENZA_1} {AppConstants.TITLE_FREQUENZA_2}</th>
                    {props.isCampo1 ? <td>{props.campo1 !== undefined ? props.campo1.anomaliaSpcNum : elemNonDisponibile}</td> : <React.Fragment />}
                    {props.isCampo2 ? <td> {props.campo2 !== undefined ? props.campo2.anomaliaSpcNum : elemNonDisponibile} </td> : <React.Fragment />}
                    <td>{props.campo3 !== undefined ? props.campo3.anomaliaSpcNum : elemNonDisponibile}</td>
                    <td>{props.campo4 !== undefined ? props.campo4.anomaliaSpcNum : elemNonDisponibile}</td>
                    {props.isCampo5 ? <td>{props.campo5 !== undefined ? props.campo5.anomaliaSpcNum : elemNonDisponibile}</td> : <React.Fragment />}
                </tr>
                */}
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.TITLE_FREQUENZA_1}{" "}
                    {AppConstants.TITLE_FREQUENZA_5}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.anomaliaSp11Num
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.anomaliaSp11Num
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {props.campo3 !== undefined
                        ? props.campo3.anomaliaSp11Num
                        : elemNonDisponibile}
                </td>
            </tr>

            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.TITLE_FREQUENZA_1}{" "}
                    {AppConstants.TITLE_FREQUENZA_3}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.anomaliaSp15Num
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.anomaliaSp15Num
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {" "}
                    {props.campo3 !== undefined
                        ? props.campo3.anomaliaSp15Num
                        : elemNonDisponibile}{" "}
                </td>
            </tr>
          
        </React.Fragment>
    )
}
export default TabIndicatoriSpecifici
